var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classNames, dispatchEvent } from '@progress/kendo-react-common';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { messages } from './messages';
import * as PropTypes from 'prop-types';
var tools = [
    { name: 'moveUp', iconClassName: 'k-icon k-i-arrow-60-up' },
    { name: 'moveDown', iconClassName: 'k-icon k-i-arrow-60-down' },
    { name: 'transferTo', iconClassName: 'k-icon k-i-arrow-60-right' },
    { name: 'transferFrom', iconClassName: 'k-icon k-i-arrow-60-left' },
    { name: 'transferAllTo', iconClassName: 'k-icon k-i-arrow-double-60-right' },
    { name: 'transferAllFrom', iconClassName: 'k-icon k-i-arrow-double-60-left' },
    { name: 'remove', iconClassName: 'k-icon k-i-x' }
];
var ListBoxToolbar = /** @class */ (function (_super) {
    __extends(ListBoxToolbar, _super);
    function ListBoxToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleToolClick = function (event, name) {
            dispatchEvent(_this.props.onToolClick, event, _this, { toolName: name });
        };
        _this.isItemDisabled = function (tool) {
            var disabled = true;
            var dataLength = _this.props.data.length;
            var dataConnectedLength = _this.props.dataConnected.length;
            var hasSelected = _this.props.data.findIndex(function (item) { return item.selected === true; }) >= 0;
            var hasSelectedTwo = _this.props.dataConnected.findIndex(function (item) { return item.selected === true; }) >= 0;
            switch (tool) {
                case 'moveUp':
                    if (hasSelected) {
                        disabled = _this.props.data.length > 0 ? _this.props.data[0].selected : true;
                    }
                    else if (hasSelectedTwo) {
                        disabled = _this.props.dataConnected.length > 0 ? _this.props.dataConnected[0].selected : true;
                    }
                    else {
                        disabled = true;
                    }
                    break;
                case 'moveDown':
                    if (hasSelected) {
                        disabled = _this.props.data[dataLength - 1] ? _this.props.data[dataLength - 1].selected : true;
                    }
                    else if (hasSelectedTwo) {
                        disabled = _this.props.dataConnected.length > 0 ?
                            _this.props.dataConnected[dataConnectedLength - 1].selected :
                            true;
                    }
                    else {
                        disabled = true;
                    }
                    break;
                case 'transferTo':
                    disabled = !(_this.props.dataConnected && hasSelected);
                    break;
                case 'transferFrom':
                    if (_this.props.dataConnected) {
                        disabled = !(_this.props.dataConnected && hasSelectedTwo);
                    }
                    else {
                        disabled = true;
                    }
                    break;
                case 'transferAllTo':
                    disabled = !(_this.props.dataConnected && _this.props.data.length > 0);
                    break;
                case 'transferAllFrom':
                    disabled = !(_this.props.dataConnected && _this.props.dataConnected.length > 0);
                    break;
                case 'remove':
                    disabled = !(hasSelected || hasSelectedTwo);
                    break;
                default:
            }
            return disabled;
        };
        return _this;
    }
    /**
     * @hidden
     */
    ListBoxToolbar.prototype.render = function () {
        var _this = this;
        var localizationService = provideLocalizationService(this);
        return (React.createElement("div", { className: classNames('k-listbox-toolbar') },
            React.createElement("ul", { className: "k-reset" }, this.props.tools && this.props.tools.map(function (tool, index) {
                var indexOfTool = tools.findIndex(function (x) { return x.name === tool; });
                var currentTool = tools[indexOfTool];
                var isDisabled = _this.isItemDisabled(currentTool.name);
                var toolKey = "listbox." + currentTool.name;
                return (React.createElement("li", { key: index },
                    React.createElement("a", { href: "#", className: classNames('k-button', 'k-button-icon', {
                            'k-state-disabled': isDisabled
                        }), "data-command": currentTool.name, title: localizationService.toLanguageString(toolKey, messages[toolKey]), "aria-label": localizationService.toLanguageString(toolKey, messages[toolKey]), role: "button", onClick: function (e) {
                            e.preventDefault();
                            _this.handleToolClick(e, currentTool.name || null);
                        } },
                        React.createElement("span", { className: currentTool.iconClassName }))));
            }))));
    };
    /**
     * @hidden
     */
    ListBoxToolbar.propTypes = {
        data: PropTypes.array,
        dataConnected: PropTypes.array,
        tools: PropTypes.array
    };
    /**
     * @hidden
     */
    ListBoxToolbar.defaultProps = {
        data: [],
        dataConnected: []
    };
    return ListBoxToolbar;
}(React.PureComponent));
export { ListBoxToolbar };
registerForLocalization(ListBoxToolbar);
//# sourceMappingURL=ListBoxToolbar.js.map